import { Injectable } from '@angular/core';
import { Action } from '../../../section/master/model/action';
import { Appointment, Schedule } from '../model/appointment'; 
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../../../shared/service/http/http-client.service';
import { CookiesService } from '../../../shared/service/cookies/cookies.service';
@Injectable()
export class AppointmentService {
  http:HttpClientService;
  cookie : CookiesService;
  objAction : Action;
  data : Schedule;
  appointmentData : Appointment;
  constructor(http : HttpClientService, cook : CookiesService) {
     this.http = http;
     this.cookie = cook;
     this.objAction  = new Action(this.http,  this.cookie);
  }
  saveSchedule() : Observable<Appointment> {   
     this.objAction.header = null;
     this.objAction.data = this.data;
     this.objAction.path = 'api/Appointment/CreateAppointmentschedule';
     return this.objAction.save();
  }
  saveAppointment() : Observable<Appointment> {   
    this.objAction.header = null;
    this.objAction.data = this.appointmentData;
    this.objAction.path = 'api/Appointment/UpdateAppointment';
    return this.objAction.update();
 }
 getPatientAppointment(patientId : number) : Observable<Appointment[]> {
    this.objAction.path = 'api/Appointment/GetPatientAppointmentDetail?PatientId='+patientId;
    return this.objAction.get();
 }
 getDoctorAppointmentForDateRange(DocId: number, ClinicId: number, StartDate: string, EndDate : string) :   Observable<Appointment[]> {
  this.objAction.path = 'api/Appointment/GetAppointmentForDateRange?DoctorId='+DocId + '&ClinicId='+ClinicId+'&StartDate='+StartDate + '&EndDate='+EndDate ;
  return this.objAction.get();
}


getDoctorAppointment( StartDate: string, EndDate : string) :   Observable<Appointment[]> {
  this.objAction.path = 'api/Appointment/GetAppointmentsByRole?StartDate='+StartDate + '&EndDate='+EndDate ;
  return this.objAction.get();
}
getUpcoming7Days(StartDate: string) :   Observable<Appointment[]> {
  this.objAction.path = 'api/Appointment/GetUpcoming7DaysAppointment?StartDate='+StartDate;
  return this.objAction.get();
}

isValidTimeForAppointment(date: string,userid:number) :   Observable<any> {
  this.objAction.path = 'api/common/IsAppTimeAllowed?OrderId='+date+'&userid='+userid;
  return this.objAction.get();
}

getCompletedAppointment() :   Observable<Appointment[]> {
  this.objAction.path = 'api/Appointment/GetCompletedAppointment';
  return this.objAction.get();
}

getPendingdAppointment() :   Observable<Appointment[]> {
  this.objAction.path = 'api/Appointment/GetPendingAppointment';
  return this.objAction.get();
}

getAllPendingAppointment(startdate: string, enddate: string) :   Observable<Appointment[]> {
  this.objAction.path = 'api/Appointment/GetAllPendingAppointment?startdate='+startdate + '&enddate='+ enddate;
  return this.objAction.get();
}

getAllMissedAppointment(startdate: string, enddate: string) :   Observable<Appointment[]> {
  this.objAction.path = 'api/Appointment/GetAllMissedAppointment?startdate='+startdate + '&enddate='+ enddate;
  return this.objAction.get();
}

getAllUpcomingAppointment(startdate: string, enddate: string) :   Observable<Appointment[]> {
  this.objAction.path = 'api/Appointment/GetAllUpcomingAppointment?startdate='+startdate + '&enddate='+ enddate;
  return this.objAction.get();
}
getAllAppointment(startdate: string, enddate: string) :   Observable<Appointment[]> {
  this.objAction.path = 'api/Appointment/GetAllAppointment?startdate='+startdate + '&enddate='+ enddate;
  return this.objAction.get();
}

getAllAppointmentsForDoc(startdate: string, enddate: string) :   Observable<Appointment[]> {
  this.objAction.path = 'api/Appointment/GetAppointmentsForDoc?startdate='+startdate + '&enddate='+ enddate;
  return this.objAction.get();
}

getAllCompletedAppointment(startdate: string, enddate: string) :   Observable<Appointment[]> {
  this.objAction.path = 'api/Appointment/GetAllCompletedAppointment?startdate='+startdate + '&enddate='+ enddate;
  return this.objAction.get();
}

GetAllTransaction(startdate: string, enddate: string) :   Observable<Appointment[]> {
  this.objAction.path = 'api/Appointment/GetAllTransaction?startdate='+startdate + '&enddate='+ enddate;
  return this.objAction.get();
}


GetAllDonationTransaction(startdate: string, enddate: string) :   Observable<any[]> {
  this.objAction.path = 'api/Appointment/GetAllDonationTransaction?startdate='+startdate + '&enddate='+ enddate;
  return this.objAction.get();
}


getAppointmentsForDoctor(docId: number):   Observable<Appointment[]> {
  this.objAction.path = 'api/Appointment/GetDoctorAppointmentDetail?DoctorId='+docId;
  return this.objAction.get();
}

GetBDAMonthlySummary(docId: number):   Observable<any[]> {
  this.objAction.path = 'api/Appointment/GetBDAMonthlySummary?DoctorId='+docId;
  return this.objAction.get();
}


  getDoctorAppointmentForMonth(DocId: number, ClinicId: number, Month: number, Year : number) :   Observable<Appointment[]> {
     this.objAction.path = 'api/Appointment/GetAppointmentForMonth?DoctorId='+DocId + '&Month='+Month + '&ClinicId='+ClinicId ;
     return this.objAction.get();
  }
  getDoctorAppointmentForDay(DocId: number, ClinicId: number, Date: string) :   Observable<Appointment[]> {
    this.objAction.path = 'api/Appointment/GetAppointmentForDay?DoctorId='+DocId + '&Date='+Date + '&ClinicId='+ClinicId ;
    return this.objAction.get();
 }
 getDoctorAppointmentForWeek(DocId: number, ClinicId: number, StartDate: string, EndDate: string) :   Observable<Appointment[]> {
  this.objAction.path = 'api/Appointment/GetAppointmentForYear?DoctorId='+DocId + '&Month='+StartDate + '&ClinicId='+ClinicId ;
  return this.objAction.get();
}
  getAppointmentForDay() :   Observable<Appointment[]> {
    this.objAction.path = 'api/Appointment/GetAppointmentForDay';
    return this.objAction.get();
  }
  getDoctorScheduleForDay(docId : number, clinicId : number, startDate : string) :   Observable<Appointment[]> {
    this.objAction.path = 'api/Appointment/GetDoctorScheduleForDay?DoctorId='+docId + '&ClinicId='+ clinicId + '&EnteredDate='+startDate;
    return this.objAction.get();
  }
  getDoctorScheduleForMultipleDay(docId : number, clinicId : number, startDate : string, endDate : string) :   Observable<Schedule[]> {
    this.objAction.path = 'api/Appointment/GetDoctorScheduleForMultipleDay?DoctorId='+docId + '&ClinicId='+ clinicId + '&StartDate='+startDate + '&EndDate='+endDate;
    return this.objAction.get();
  }

  getDoctorAbsenceMultipleDay(startDate : string, endDate : string) :   Observable<any> {
    this.objAction.path = 'api/users/GetAbsenceForDateRange?StartDate='+startDate + '&EndDate='+endDate;
    return this.objAction.get();
  }

  getDoctorScheduleForAbsence(startDate : string, endDate : string) :   Observable<any> {
    this.objAction.path = 'api/users/getDoctorScheduleForAbsence?StartDate='+startDate + '&EndDate='+endDate;
    return this.objAction.get();
  }

  updateAppointment() : Observable<Appointment> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = 'api/Appointment/UpdateAppointment';
    return this.objAction.update();
  }
  deleteSchedule(docId : number, clinicId : number, date : string, time : string) :   Observable<string> {
    this.objAction.path = 'api/Appointment/DeleteDoctorScheduled?DoctorId='+docId + '&ClinicId='+ clinicId + '&Date='+date + '&Time='+time;
    return this.objAction.delete();
  }
  deactivateSchedule(docId : number, clinicId : number, date : string, time : string) :   Observable<any> {
    this.objAction.path = 'api/Appointment/DeActivateDoctorScheduled?DoctorId='+docId + '&ClinicId='+ clinicId + '&Date='+date + '&Time='+time;
    return this.objAction.update();
  }
  activateSchedule(docId : number, clinicId : number, date : string, time : string) :   Observable<any> {
    this.objAction.path = 'api/Appointment/ActivateDoctorScheduled?DoctorId='+docId + '&ClinicId='+ clinicId + '&Date='+date + '&Time='+time;
    return this.objAction.update();
  }
  
 
  cancelAppointment(docId : number, clinicId : number, date : string, time : string) :   Observable<any> {
    this.objAction.path = 'api/Appointment/CancelAppointment?DoctorId='+docId + '&ClinicId='+ clinicId + '&Date='+date + '&Time='+time;
    return this.objAction.update();
  }

  copySchedule():   Observable<string> {
    this.objAction.data = this.data;
    this.objAction.path = 'api/Appointment/CopyDoctorScheduled';
    return this.objAction.save();
  }

  rescheduleSchedule(data : any):   Observable<string> {
    this.objAction.data = data;
    this.objAction.path = 'api/Appointment/RescheduleAppointment';
    return this.objAction.update();
  }
  getTimeSlots(Id: number) :   Observable<any[]> {
    this.objAction.path = 'api/Slots/GetSlots?DoctorId='+ Id
   return this.objAction.get();
 }

  deleteAbsence():   Observable<any> {
    this.objAction.data = this.appointmentData;
    this.objAction.path = 'api/users/DeleteAbsence';
    return this.objAction.save();
  }
  
  saveAbsence(data:any):   Observable<any> {
    this.objAction.data = data;
    this.objAction.path = 'api/users/SaveAbsence';
    return this.objAction.save();
  }

  GetCancelRefund(type: string) :   Observable<any[]> {
    this.objAction.path = 'api/Users/GetCancelRefund?type='+ type;
   return this.objAction.get();
  }

  ApproveCancelOrder(data:any):   Observable<any> {
    this.objAction.data = {OrderNo : data};
    this.objAction.path = 'api/users/UpdateCancelRefundStatus';
    return this.objAction.save();
  }


  savePayment(data:any):   Observable<any> {
    this.objAction.data = data;
    this.objAction.path = 'api/appointment/SavePaidAmount';
    return this.objAction.save();
  }
}



// WEBPACK FOOTER //
// ./src/app/section/appointment/service/appointment.service.ts